module.exports = __webpack_public_path__ + "static/media/consensys-thumbnail.a0a49654.jpg";